import ArrowBack from '@mui/icons-material/ArrowBack';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import { Box, Fab, IconButton } from '@mui/material';

const PDFNavigation = ({ usePDFSlickStore, onClose }) => {
  const pageNumber = usePDFSlickStore(s => s.pageNumber);
  const numPages = usePDFSlickStore(s => s.numPages);
  const pdfSlick = usePDFSlickStore(s => s.pdfSlick);
  const scale = usePDFSlickStore(s => s.scale);

  return (
    <>
      <Fab
        sx={{
          position: 'absolute',
          top: 16,
          left: 16,
          zIndex: 1000,
          backgroundColor: 'white'
        }}
        aria-label="back"
        onClick={onClose}
      >
        <ArrowBack />
      </Fab>
      <Box
        sx={{
          position: 'fixed',
          bottom: 16,
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'white',
          padding: 1,
          borderRadius: '20%',
          boxShadow: 2,
          zIndex: 1000
        }}
      >
        {/* Previous Button */}
        <IconButton disabled={pageNumber === 1} onClick={() => pdfSlick?.gotoPage(pageNumber - 1)}>
          <NavigateBeforeIcon />
        </IconButton>
        {/* Zoom Out */}
        <IconButton
          disabled={!pdfSlick || scale <= 0.25}
          onClick={() => pdfSlick?.viewer?.decreaseScale()}
        >
          <ZoomOutIcon />
        </IconButton>
        {/* Zoom In */}
        <IconButton
          disabled={!pdfSlick || scale >= 5}
          onClick={() => pdfSlick?.viewer?.increaseScale()}
        >
          <ZoomInIcon />
        </IconButton>
        {/* Next Button */}
        <IconButton
          disabled={numPages <= pageNumber}
          onClick={() => pdfSlick?.gotoPage(pageNumber + 1)}
        >
          <NavigateNextIcon />
        </IconButton>
      </Box>
    </>
  );
};

export default PDFNavigation;
